import { ResourceList } from "src/system/ResourceList.tsx";
import { ResourceEnum } from "src/constants/constants.ts";
import { Suspense, useMemo, useState } from "react";
import { useResourceFormData } from "src/components/Form/hooks/useResourceFormData.ts";
import type { EditDocumentFormData } from "src/admin/modules/document/forms/document/config.tsx";
import { type DocumentResource, DocumentTypes } from "@exonn/js-sdk";
import { useTranslation } from "react-i18next";
import { TranslationNamespaceEnum } from "src/lib/i18next/types.ts";
import type { GridFilterModel } from "@mui/x-data-grid-premium";
import { useGlobalModuleTabs } from "src/App/useGlobalModuleTabs.ts";
import { FormAction } from "src/components/Form/Form.types.ts";

export const RecurringRuns = () => {
  const data = useResourceFormData<EditDocumentFormData>();
  const { t } = useTranslation();
  const { api } = useGlobalModuleTabs();

  const filter = useMemo((): GridFilterModel => {
    const resource = data?.data;

    return {
      items: [
        {
          field: "process_number",
          value: resource?.process_number,
          operator: "exact",
        },
        {
          field: "document_type",
          value: DocumentTypes.Invoice,
          operator: "is",
        },
      ],
    };
  }, [data]);

  const [selectedRow, setSelectedRow] = useState<DocumentResource | null>(null);

  if (!data) {
    return null;
  }

  const openDocument = (resource: DocumentResource) => {
    api.openTab({
      resource: ResourceEnum.Document,
      type: "form",
      action: FormAction.Edit,
      id: resource.id,
    });
  };

  return (
    <Suspense fallback={null}>
      <ResourceList
        style={{
          padding: 15,
        }}
        contextMenu={{
          selectedRow,
          onSelectedRowChange: setSelectedRow,
          items: [
            {
              icon: <span className={"icon-15-edit"} />,
              label: t("actions.edit", {
                ns: TranslationNamespaceEnum.Common,
              }),
              key: "edit",
              onSelect: (row: DocumentResource) => {
                openDocument(row);
              },
            },
          ],
        }}
        onRowDoubleClick={({ row }) => {
          openDocument(row);
        }}
        hideToolbarCreateNewRecordButton
        resource={ResourceEnum.RecurringDocument}
        filter={filter}
      />
    </Suspense>
  );
};
